import { render, staticRenderFns } from "./SalOrderItemDetail.vue?vue&type=template&id=71306754&scoped=true"
import script from "./SalOrderItemDetail.vue?vue&type=script&lang=js"
export * from "./SalOrderItemDetail.vue?vue&type=script&lang=js"
import style0 from "./SalOrderItemDetail.vue?vue&type=style&index=0&id=71306754&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71306754",
  null
  
)

export default component.exports